module.exports = __webpack_public_path__ + "static/media/icon-download.9e4397fc.gif";